<template>
  <div v-if="user">
    <h1>CRON</h1>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['user'])
  }
}
</script>